//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'baseLayoutCol',
  props: {
    span: {
      type: Number,
      default: 24
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    independentTitle: {
      type: Boolean,
      default: false
    },
    noBackgroundTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/baseLayout/baseLayoutCol.vue